import { defineStore } from 'pinia';

import { MerchantService } from '~/support/services';

export const useMerchantStore = defineStore('merchant', () => {
  const config = useRuntimeConfig();
  const service = new MerchantService(config.public.apiBaseUrl);

  function find(storeId) {
    return service.find(storeId);
  }

  return {
    find,
  };
});
